/**
 * Sequence detail path builder.
 *
 * Sequence pages live at /sequence/:idOrSlug. The slug (generated by the
 * 20260819_sequence_slug_autogen migration as "{song}-{artist}") is the
 * canonical, SEO-preferred URL segment; the raw UUID id remains the
 * fallback until every row has been backfilled. Route all internal
 * sequence links through this helper so the two shapes never drift.
 */

/** Any object carrying a sequence id plus its optional slug. */
export interface SequencePathTarget {
  id: string;
  slug?: string | null;
}

/** Canonical internal path for a sequence detail page. */
export const buildSequencePath = (sequence: SequencePathTarget): string =>
  `/sequence/${sequence.slug || sequence.id}`;

const SEQUENCE_SECTION_PREFIXES = [
  '/sequence', // /sequence/:id, /sequences, /sequences/*, /sequencer/*, /sequencers
  '/songs',
  '/creators',
  '/upload-sequence',
  '/my-sequences',
  '/sell',
  '/seller',
  '/purchase-success',
];

/** True on pages about sequences, where the header offers "Upload sequence" instead of "Add a display". */
export const isSequenceSectionPath = (pathname: string): boolean =>
  SEQUENCE_SECTION_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(prefix));
